import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AppUtil } from '../../../utils/app.util';

const FOOTER_HEIGHT_CSS_VAR = '--footer-height';
/*** Footer Component */
@Component({
	selector: 'app-ehe-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
	/** Footer Type */
	@Input() type: string;
	/** denote whether to show social network links or not */
	@Input() socialNetwork: boolean = false;
	/** Style 'TOP' value */
	@Input() top: string;
	/** Holds current year value */
	currentYear: any = AppUtil.getCurrentYear();

	private resizeObserver: ResizeObserver | null = null;

	constructor(private el: ElementRef<HTMLElement>) {}

	ngOnInit(): void {
		const footerEl = this.el.nativeElement.querySelector('.copyright-footer') ?? this.el.nativeElement;
		const setHeight = () => {
			const height = (footerEl as HTMLElement).offsetHeight;
			if (height > 0) {
				document.body.style.setProperty(FOOTER_HEIGHT_CSS_VAR, `${height}px`);
			}
		};
		setHeight();
		if (typeof ResizeObserver !== 'undefined') {
			this.resizeObserver = new ResizeObserver(setHeight);
			this.resizeObserver.observe(footerEl as HTMLElement);
		}
	}

	ngOnDestroy(): void {
		this.resizeObserver?.disconnect();
		this.resizeObserver = null;
		document.body.style.removeProperty(FOOTER_HEIGHT_CSS_VAR);
	}

	openCookiesPreferences($event) {
		$event.preventDefault();
		console.log('Open Cookies Preferences');
		window['Osano']?.cm?.showDrawer?.('osano-cm-dom-info-dialog-open');
	}
}
